import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const entitlementImporterSelectors = importerSelectors(
  'entitlement.importer',
);

export default entitlementImporterSelectors;
